document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector("div#track123-powered-by");
  if (el) {
    el.style.setProperty("display", "none", "important");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".track123_order_wrapper.track123_track_data");
  if (wrapper) {
    const sections = wrapper.querySelectorAll(".track123_order_detail_section");
    let allEmpty = true;

    sections.forEach(section => {
      // Check if there's any non-empty text or element node
      const hasContent = Array.from(section.childNodes).some(node => {
        return (node.nodeType === 1) || // element node
               (node.nodeType === 3 && node.textContent.trim().length > 0); // text node with text
      });

      if (hasContent) {
        allEmpty = false;
      }
    });

    if (allEmpty) {
      wrapper.style.display = "none";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const btns = document.querySelectorAll(".swym-storefront-layout-grid-item-add-to-cart-button");
    btns.forEach(btn => {
      btn.textContent = btn.textContent.replace("+", "").trim();
    });
  }, 5000);
});

document.addEventListener("DOMContentLoaded", function () {
  let lastScrollTop = 0;

  window.addEventListener("scroll", function () {
    const currentScroll = window.scrollY;
    const widgets = document.querySelectorAll(
      ".buckscc-floating-box"
    );

    widgets.forEach((widget) => {
      if (currentScroll > lastScrollTop) {
        // Scrolling down
        widget.classList.add("hide-on-scroll");
      } else {
        // Scrolling up
        widget.classList.remove("hide-on-scroll");
      }
    });

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
});


// Moving Search on smaller screens

document.addEventListener("DOMContentLoaded", function() {
  const searchButton = document.querySelector(".site-header__open-search");
  const mobileNavToggle = document.querySelector(".mobile-nav-toggle");

  function moveSearchButton() {
    if (window.innerWidth <= 640) {
      if (!mobileNavToggle.contains(searchButton)) {
        mobileNavToggle.appendChild(searchButton);
      }
    } else {
      const headerRight = document.querySelector(".site-header__addons");
      if (headerRight && !headerRight.contains(searchButton)) {
        headerRight.insertBefore(searchButton, headerRight.firstChild);
      }
    }
  }

  // Run after 3 seconds
  setTimeout(() => {
    moveSearchButton();
    window.addEventListener("resize", moveSearchButton);
  }, 2500);
});


document.addEventListener('DOMContentLoaded', function() {
  // Select all .list-container elements
  const listContainers = document.querySelectorAll('.page-designers .list-container');

  if (listContainers.length > 0) {
    // Get the parent node of the first .list-container
    const parent = listContainers[0].parentNode;

    // Loop over the .list-container elements in chunks of 5
    for (let i = 0; i < listContainers.length; i += 3) {
      // Create a new wrapper div
      const brandCol = document.createElement('div');
      brandCol.classList.add('brand_col');

      // Insert the wrapper before the current chunk
      parent.insertBefore(brandCol, listContainers[i]);

      // Move up to 5 .list-container elements into this wrapper
      for (let j = i; j < i + 3 && j < listContainers.length; j++) {
        brandCol.appendChild(listContainers[j]);
      }
    }
  }
});
